import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, intlShape } from 'react-intl';
import { commonMessages } from '../../../messages/commonMessages';

import Modal from '../../common/Modal';

class HamburgerMenu extends PureComponent {
  state = {
    menuIsExpanded: false,
  };

  componentDidMount() {
    window.addEventListener('resize', this.onResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    if (window.innerWidth >= 1025 && this.state.menuIsExpanded) {
      this.closeMenu();
    }
  };

  render() {
    return (
      <React.Fragment>
        <button
          onClick={this.openMenu}
          aria-label={
            this.state.menuIsExpanded
              ? this.props.intl.formatMessage(commonMessages.closeMenu)
              : this.props.intl.formatMessage(commonMessages.openMenu)
          }
        >
          <svg className="hamburger" viewBox="0 0 24 24" fill="white">
            <path d="M3 11.2h18v1.6h-18v-1.6z" />
            <path d="M3 5.2h18v1.6h-18v-1.6z" />
            <path d="M3 17.2h18v1.6h-18v-1.6z" />
          </svg>
        </button>
        <Modal animated isOpen={this.state.menuIsExpanded} onClose={this.closeMenu}>
          {React.Children.map(this.props.children, child =>
            React.cloneElement(child, { closeMenu: this.closeMenu })
          )}
        </Modal>
      </React.Fragment>
    );
  }

  openMenu = () => {
    this.setState({ menuIsExpanded: true });
  };

  closeMenu = () => {
    this.setState({ menuIsExpanded: false });
  };
}

HamburgerMenu.propTypes = {
  children: PropTypes.node,
  intl: intlShape.isRequired,
};

export default injectIntl(HamburgerMenu);



// WEBPACK FOOTER //
// /tmp/build_83f21ab6/src/components/main/header/HamburgerMenu.js